export const FILTER_KEYS = ['status', 'categories', 'providerIn'] as const;

export type FilterKeys = (typeof FILTER_KEYS)[number];

export const FILTER_RANGE_KEYS = ['price', 'rating'];

export const GO_LIVE_DATE_FILTER_OPTIONS = [
  { name: '1 week ago', value: 1 },
  { name: '2 weeks ago', value: 2 },
  { name: '4 weeks ago', value: 4 },
] as const;
